import React from "react";
import { useState } from "react";
import { Button, TextField, Grid } from "@mui/material";
import * as sweetalert from "sweetalert";
import axios from "axios";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const Form = ({
  id,
  fundtype,
  fundtype1,
  fundtype2,
  fundtype3,
  fundtype4,
}) => {
  const fundName = fundtype.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_name;
    }
  });
  const fundCompany = fundtype2.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_company;
    }
  });
  const priceGeneralDistributor = fundtype3.map((element) => {
    if (element["p"].id === id) {
      return element["p"].price_for_general_distributor;
    }
  });

  const pricesSpecialDistributor = fundtype4.map((element) => {
    if (element["p"].id === id) {
      return element["p"].price_for_special_distributor;
    }
  });
  const fundType = fundtype1.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_type;
    }
  });

  const [formValues, setFormValues] = useState({
    fund_name: {
      value: fundName.filter((e) => e !== undefined),
    },
    fund_company: {
      value: fundCompany.filter((e) => e !== undefined),
    },
    price_for_general_distributor: {
      value: priceGeneralDistributor.filter((e) => e !== undefined),
    },
    price_for_special_distributor: {
      value: pricesSpecialDistributor.filter((e) => e !== undefined),
    },
    fund_type: {
      value: fundType.filter((e) => e !== undefined),
    },
  });
  const onSubmit = (event) => {
    event.preventDefault();
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: null,
        sameSite: "strict",
      },
    };
    const data = {
      fund_name: event.target.fund_name.value,
      fund_type: event.target.fund_type.value,
      fund_company: event.target.fund_company.value,
    };
    axios
      .get(
        `${BaseUrl}/sanctum/csrf-cookie`,
        config
      )
      .then((response) => {
        axios
          .post(
            `${BaseUrl}/api/updateFund/${id}`,
            data,
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (res.status === 200) {
              sweetalert("تمت علية التعديل بنجاح");
              window.location.reload();
            } else {
              sweetalert("error");
            }
          });
      });
  };

  const handleChange = (e) => {
    e.persist();

    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  return (
    <form
      onSubmit={onSubmit}
      initialValues={{
        fund_name: formValues.fund_name.value,
      }}
    >
      <div className="form-group">
        <Grid container maxWidth="sm" spacing={2}>
          <Grid item md={6} xs={12}>
            return (
            <TextField
              label="  النوع"
              type="text"
              className="form-control"
              id="fund_type"
              name="fund_type"
              onChange={handleChange}
              value={formValues.fund_type.value}
              inputProps={{ readOnly: true }}
            />
            );
          </Grid>
          <Grid item md={6} xs={12}>
            return (
            <TextField
              label="  اسم الشركة"
              type="text"
              className="form-control"
              id="fund_company"
              name="fund_company"
              onChange={handleChange}
              value={formValues.fund_company.value}
            />
            );
          </Grid>
        </Grid>
      </div>

      <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
        <Button
          type="submit"
          variant="contained"
          className="btn-submit"
          color="secondary"
        >
          حفظ
        </Button>
      </Grid>
    </form>
  );
};
export default Form;
